const UNIT_BASED_DISPLAYS = new Set([
  'pzas',
  'pza',
  'piezas',
  'pieza',
  'botellas',
  'botella',
  'unidades',
  'unidad',
  'pz',
]);

export function ingredientUsesUnits(ing) {
  const unit = String(ing?.unit_display || 'kg').trim().toLowerCase();
  return UNIT_BASED_DISPLAYS.has(unit);
}

export function ingredientStockQuantity(ing) {
  if (ingredientUsesUnits(ing)) {
    return Number(ing?.stock_units ?? ing?.stock_grams ?? 0);
  }
  return Number(ing?.stock_kg ?? 0);
}

export function ingredientLowStockQuantity(ing) {
  if (ingredientUsesUnits(ing)) {
    const v = ing?.low_stock_units ?? ing?.low_stock_grams ?? 0;
    return Number(v) > 0 ? Number(v) : 0;
  }
  return Number(ing?.low_stock_kg ?? 0);
}

export function ingredientStockUnitLabel(ing) {
  return ingredientUsesUnits(ing) ? 'pzas' : 'kg';
}

/** Valor listo para inputs del diálogo de ajuste (misma lógica que la tabla). */
export function formatQuantityInput(ing, qty) {
  const n = Number(qty);
  if (!Number.isFinite(n)) return '0';
  if (ingredientUsesUnits(ing)) return String(Math.round(n));
  return String(parseFloat(n.toFixed(3)));
}

const UNIT_BASED_DISPLAYS_LOOKUP = UNIT_BASED_DISPLAYS;

export function ingredientUsesUnitsFromDisplay(unitDisplay) {
  const unit = String(unitDisplay || 'kg').trim().toLowerCase();
  return UNIT_BASED_DISPLAYS_LOOKUP.has(unit);
}

export function consumptionQuantityFromItem(item) {
  if (ingredientUsesUnitsFromDisplay(item?.unit_display)) {
    return Number(item?.consumed_grams ?? 0);
  }
  return Number(item?.consumed_kg ?? 0);
}

export function consumptionUnitLabelFromItem(item) {
  return ingredientUsesUnitsFromDisplay(item?.unit_display) ? 'pzas' : 'kg';
}

export function formatConsumptionQuantity(item) {
  const qty = consumptionQuantityFromItem(item);
  const unit = consumptionUnitLabelFromItem(item);
  if (unit === 'pzas') return String(Math.round(qty));
  return qty.toFixed(3);
}

const MOVEMENT_REASON_LABELS = {
  kitchen_consume: 'Cocina',
  counter_consume: 'Caja',
  manual_adjust: 'Ajuste manual',
};

export function inventoryMovementReasonLabel(reason) {
  return MOVEMENT_REASON_LABELS[String(reason || '')] || String(reason || '—');
}

const PRODUCTION_CONSUME_REASONS = new Set(['kitchen_consume', 'counter_consume']);

export function isProductionConsumeMovement(movement) {
  return PRODUCTION_CONSUME_REASONS.has(String(movement?.reason || ''));
}

export function sumProductionConsumption(movements, ing) {
  const usesUnits = ingredientUsesUnits(ing);
  return (movements || []).reduce((sum, m) => {
    if (!isProductionConsumeMovement(m)) return sum;
    const delta = Number(m.delta_grams ?? 0);
    if (delta >= 0) return sum;
    return sum + (usesUnits ? Math.abs(delta) : Math.abs(Number(m.delta_kg ?? 0)));
  }, 0);
}
